import { isSaturday, lastDayOfMonth, nextSaturday } from 'date-fns';

// this func take into account end of week according to app business logic (add days from next month to show whole week)
// use only for week mode
const getToDate = (date: Date, dateFormat?: boolean): string | Date => {
  const endOfMonthDate = lastDayOfMonth(date);
  const saturday = isSaturday(endOfMonthDate);
  const nextSat = saturday ? endOfMonthDate : nextSaturday(endOfMonthDate);
  if (dateFormat) {
    return nextSat;
  }
  return new Date(nextSat.setHours(12)).toISOString();
};

export default getToDate;
